import React, { Component } from "react";
import { string } from "prop-types";
import { INPUT_TYPES } from "utils/CommonConstants";
import { PopUp } from "styled_components/Common/PopUp";
import { BloxButton } from "styled_components/Common/BloxButton";
import Modal from "sub_components/Common/PortalModalNew";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import TextInput from "sub_components/Common/BloxTextInput";
import RadioButton from "sub_components/Common/Radio";
import DateTimeClock from "sub_components/Common/DateTimePicker";
import format from "date-fns/format";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const closeButton = `${CDN_URL}common/modal-x-button-default-lg.svg`;
const closeHover = `${CDN_URL}common/modal-X-button-hover.svg`;

const PREFERENCES = {
  REQUIRED: "REQUIRED",
  OPTIONAL: "OPTIONAL",
};

const OPTIONS = [
  { name: PREFERENCES.REQUIRED, value: PREFERENCES.REQUIRED },
  { name: PREFERENCES.OPTIONAL, value: PREFERENCES.OPTIONAL },
];

class CreateCalendarEvent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: "",
      title: "",
      completedFields: [],
      attendee: "",
      attendeePreference: "",
      attendees: [],
      showStart: false,
      showEnd: false,
      dropdownOpen: false,
      dropdownOpenReminder: false,
      recurring: "Select one",
      reminder: "15 mins",
      reminderValue: 15,
      clicked: false,
      createError: false,
    };
  }

  componentDidMount() {
    const { type, eventDetails } = this.props;
    if (type === "update" && eventDetails) {
      const attendees = eventDetails?.attendees;
      const newAttendees = [];
      attendees.map((attendee) =>
        newAttendees.push({
          email: attendee?.emailAddress?.address,
          type: attendee?.type,
        })
      );
      this.setState({ attendees: newAttendees });
    }
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onFieldComplete = (field, isValid) => {
    const { completedFields: fields } = this.state;
    //const { id, updateProgress } = this.props;

    if (isValid) {
      if (!fields.includes(field)) {
        fields.push(field);
      }
    } else {
      if (fields.includes(field)) {
        const index = fields.indexOf(field);
        fields.splice(index, 1);
      }
    }

    //updateProgress(id, fields.length);
    this.setState({ completedFields: fields });
  };

  onPreferenceChange = (attendeePreference) => {
    this.onFieldComplete("attendeePreference", true);
    this.setState({ attendeePreference });
  };
  saveAttendee = () => {
    const { setAttendees } = this.props;
    const { attendee, attendeePreference, attendees } = this.state;

    const newAttendees = [...attendees];

    newAttendees.push({ email: attendee, type: attendeePreference });
    setAttendees(newAttendees);
    this.setState({
      attendee: "",
      attendeePreference: "",
      attendees: newAttendees,
    });
  };

  toggleModal = () => {
    const { modalOpen } = this.state;
    this.setState({ modalOpen: !modalOpen });
  };

  removeAttendee = (email) => {
    const { setAttendees } = this.props;
    const { attendees } = this.state;
    let newAttendees = [...attendees];
    newAttendees = newAttendees.filter((attendee) => attendee?.email !== email);
    setAttendees(newAttendees);
    this.setState({ attendees: newAttendees });
  };
  checkEmailAddress = (email) => {
    if (email.includes("@dcblox.com")) {
      return false;
    } else {
      return true;
    }
  };
  setValue = () => {
    const { startdatetime, enddatetime } = this.props;
    if (!startdatetime || isNaN(new Date(startdatetime))) {
      return "";
    }

    const startDate = new Date(startdatetime);

    // If no end date exists or is invalid, just return formatted start date
    if (!enddatetime || isNaN(new Date(enddatetime))) {
      return format(startDate, "MMMM do yyyy");
    }

    const endDate = new Date(enddatetime);

    // Check if dates are the same day
    const isSameDay =
      startDate.getDate() === endDate.getDate() &&
      startDate.getMonth() === endDate.getMonth() &&
      startDate.getFullYear() === endDate.getFullYear();

    if (isSameDay) {
      return format(startDate, "MMMM do yyyy");
    } else {
      // If month and year are the same
      if (
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getFullYear() === endDate.getFullYear()
      ) {
        return format(startDate, "MMMM d") + "-" + format(endDate, "d yyyy");
      }
      // If only year is the same
      else if (startDate.getFullYear() === endDate.getFullYear()) {
        return (
          format(startDate, "MMMM d") + "-" + format(endDate, "MMMM d yyyy")
        );
      }
      // If everything is different
      else {
        return (
          format(startDate, "MMMM d yyyy") +
          "-" +
          format(endDate, "MMMM d yyyy")
        );
      }
    }
  };

  getTimezone = (location) => {
    let timezone = "";
    if (
      location === "CHA" ||
      location === "ATL" ||
      location === "GSP" ||
      location === "MYR"
    ) {
      timezone = "Eastern Standard Time";
    } else if (location === "HSV" || location === "BHM") {
      timezone = "Central Standard Time";
    } else {
      timezone = "Eastern Standard Time";
    }
    return timezone;
  };

  render() {
    const {
      attendee,
      attendeePreference,
      attendees,
      modalOpen,
      modalContent,
      headerText,
      customTitle,
    } = this.state;
    const {
      startdatetime,
      setNewStartTime,
      setNewStartDateTime,
      location,
      showStart,
      showStartDateTimeClock,
      breakpoint,
    } = this.props;

    return (
      <div className="create-calendar-event-wrapper">
        {modalOpen && (
          <Modal>
            <PopUp
              showModal={modalOpen}
              customBody={modalContent}
              closeModal={this.toggleModal}
              footer={
                <BloxButton
                  className="buttons41"
                  id="okay"
                  text="OKAY"
                  module="support"
                  enabled={true}
                  onClick={this.toggleModal}
                  cypressId="okay"
                />
              }
              title={customTitle}
              text={headerText}
              module="support"
            />
          </Modal>
        )}

        <div className="attendees-picker">
          {" "}
          <TextInput
            placeholder="email"
            label="Add Attendees email."
            name="attendee"
            value={attendee}
            onChange={this.onChange}
            markComplete={this.onFieldComplete}
            active={true}
            showCharacterCount={false}
            hideCheckmark
          />
          <RadioButton
            callback={this.onPreferenceChange}
            label=""
            name="attendeePreference"
            value={attendeePreference}
            //hidden={radioHidden}
            toggle={true}
            options={OPTIONS}
          />
          <div className="attendees-add">
            <BloxButton
              className="buttons41"
              id="add-attendee"
              text="ADD ATTENDEE"
              module="support"
              enabled={attendee && attendeePreference ? true : false}
              onClick={this.saveAttendee}
              cypressId="add-attendee"
            />
          </div>
        </div>
        {attendees && attendees.length !== 0 && (
          <div className="attendees">
            <ScrollView>
              {attendees.map((attendee) => {
                return (
                  <div className="attendee">
                    <div className="email body10">{attendee?.email}</div>
                    <div className="type body10">{attendee?.type}</div>
                    {this.checkEmailAddress(attendee?.email) && (
                      <div
                        className="remove-button"
                        onClick={() => this.removeAttendee(attendee?.email)}
                      >
                        <img
                          src={closeButton}
                          onMouseOver={(e) => (e.target.src = closeHover)}
                          onMouseOut={(e) => (e.target.src = closeButton)}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </ScrollView>
          </div>
        )}
        <div className="time-pickers">
          <div className="start-datetime-picker">
            <div className="date-and-time">
              <TextInput
                placeholder=""
                type={INPUT_TYPES.INPUT}
                label="Choose a start & end date"
                name="start-date-time"
                value={this.setValue()}
                onClick={showStartDateTimeClock}
                active={true}
                onChange={this.onInputChange}
                hideCheckmark
              />
              {showStart && (
                <DateTimeClock
                  show={showStart}
                  displayDate={format(new Date(startdatetime), "MMMM do yyyy")}
                  callback={setNewStartDateTime}
                  time={format(new Date(startdatetime), "h:mm")}
                  finishedCallback={setNewStartTime}
                  breakpoint={breakpoint}
                  closeModal={showStartDateTimeClock}
                />
              )}
            </div>
            <div className="timezone-wrapper">
              <div className="label labels22">Time Zone:</div>
              <div className="value body10">{this.getTimezone(location)}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CreateCalendarEvent.propTypes = {
  type: string,
};
CreateCalendarEvent.defaultProps = {
  type: "create",
};

export default CreateCalendarEvent;
